module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Single Table",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.singleTable
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sViewName",
      "label": "Favorite"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "label": "Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nDownloads",
      "label": "Downloads"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total1
    },
    on: {
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view1.sViewName,
      "visible": _vm.dialogVisible1,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible1 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.view1.sContent.sName))]), _vm._v(" "), _vm._l((_vm.view1.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(item.sColumnName))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.fuhao))]), _vm._v(" "), _c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(_vm.arrToString(item.value)))])])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Columns"
    }
  }, _vm._l((_vm.view1.sContent.sSelectFieldName), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "span-label"
    }, [_vm._v(_vm._s(_vm.zhuanhuanItem(item)))])
  }), 0)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doDownload1
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doEdit1
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delete1
    }
  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view1.sViewName + 'Edit',
      "visible": _vm.dialogVisible11,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible11 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.view1.sContent.sName))]), _vm._v(" "), _vm._l((_vm.view1.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Select",
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.change2(item)
        }
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }, _vm._l((_vm.options3), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnName,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.fuhao),
        callback: function($$v) {
          _vm.$set(item, "fuhao", $$v)
        },
        expression: "item.fuhao"
      }
    }, _vm._l((_vm.options4), function(a) {
      return (item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1) ? _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      }) : _vm._e()
    }), 1), _vm._v(" "), (item.type != 'Datetime' && _vm.view1.sContent.sSelectName != 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-select', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "multiple": "",
        "multiple-limit": item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1,
        "filterable": "",
        "remote": "",
        "reserve-keyword": "",
        "placeholder": item.type,
        "data-id": index,
        "remote-method": _vm.querySearchAsync,
        "loading": _vm.loading
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1) : (item.type != 'Datetime' && _vm.view1.sContent.sSelectName == 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }) : _c('el-date-picker', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "format": "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "prefix-icon": "xxx",
        "type": "datetime",
        "placeholder": item.type
      },
      model: {
        value: (item.value[0]),
        callback: function($$v) {
          _vm.$set(item.value, 0, $$v)
        },
        expression: "item.value[0]"
      }
    }), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addList(_vm.view1.sContent.sSelectFilter)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteList(_vm.view1.sContent.sSelectFilter, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Columns"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange
    },
    model: {
      value: (_vm.view1.sContent.sSelectFieldName),
      callback: function($$v) {
        _vm.$set(_vm.view1.sContent, "sSelectFieldName", $$v)
      },
      expression: "view1.sContent.sSelectFieldName"
    }
  }, _vm._l((_vm.options3), function(item) {
    return _c('el-checkbox', {
      key: item.sColumnCode,
      attrs: {
        "label": item.sColumnCode
      }
    }, [_vm._v(_vm._s(item.sColumnName))])
  }), 1)], 1)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save1
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save11
    }
  }, [_vm._v("save as")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible11 = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view1.sViewName + 'Display result',
      "visible": _vm.dialogVisible2,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [(_vm.count < 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showListFlag = !_vm.showListFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.showListFlag == true ? 'Hide' : 'Display'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addDownLoad
    }
  }, [_vm._v("\n\t\t\t\t\tDownload\n\t\t\t\t\t"), (_vm.timer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.timer) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showListFlag) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #eee",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "500px",
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, _vm._l((_vm.view1.sContent.sSelectFieldName), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "width": "200",
        "formatter": _vm.timeFormatter,
        "prop": item,
        "label": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.count >= 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "10px 0"
    }
  }, [_c('h2', [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("\n\t\t\t\t\tToo much data,unable to export!\n\t\t\t\t")])]) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Multi Table",
      "name": "second"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData2,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.multiTable
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sViewName",
      "label": "Favorite"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "label": "Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nDownloads",
      "label": "Downloads"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view2.sViewName,
      "visible": _vm.dialogVisible3,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible3 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_vm._l((_vm.view2.sContent.table), function(item, index) {
    return _c('el-form-item', {
      key: item.nSelectId,
      attrs: {
        "label": 'Table' + (index + 1)
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.sName) + "(" + _vm._s(item.sBie) + ")\n\t\t\t\t")])
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.keys), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Keys' + (index + 1)
      }
    }, _vm._l((item.selectKey), function(a, index) {
      return _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.sName1) + "(" + _vm._s(item.sBie1) + ")." + _vm._s(_vm.stringArr(a, 0)) + "=" + _vm._s(item.sName2) + "(" + _vm._s(item.sBie2) + ")." + _vm._s(_vm.stringArr(a, 1)) + "\n\t\t\t\t\t\t"), (index != item.selectKey.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()])
    }), 0)
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(item.sName) + "(" + _vm._s(item.sBie) + ")." + _vm._s(item.sColumnName))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.fuhao))]), _vm._v(" "), _c('span', {
      staticClass: "span-label"
    }, [_vm._v(_vm._s(_vm.arrToString(item.value)))])])
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.sSelectFieldName), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Columns"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.sNameAll + '(' + item.sBie + ')' + '.Columns'))]), _vm._v(" "), _vm._l((item.value), function(a) {
      return _c('span', {
        staticClass: "span-label"
      }, [_vm._v(_vm._s(_vm.zhuanhuanItem2(item.options, a)))])
    })], 2)
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doDownload2
    }
  }, [_vm._v("DownLoad")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doEdit2
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delete2
    }
  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view2.sViewName + 'Edit',
      "visible": _vm.dialogVisible31,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible31 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_vm._l((_vm.view2.sContent.table), function(item, index) {
    return _c('el-form-item', {
      key: item.nSelectId,
      attrs: {
        "label": 'Table' + (index + 1)
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.sName) + "(" + _vm._s(item.sBie) + ")\n\t\t\t\t")])
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.keys), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Keys' + (index + 1)
      }
    }, _vm._l((item.selectKey), function(a, index) {
      return _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.sName1) + "(" + _vm._s(item.sBie1) + ")." + _vm._s(_vm.stringArr(a, 0)) + "=" + _vm._s(item.sName2) + "(" + _vm._s(item.sBie2) + ")." + _vm._s(_vm.stringArr(a, 1)) + "\n\t\t\t\t\t\t"), (index != item.selectKey.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()])
    }), 0)
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Select",
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.change4(item, index, _vm.view2.sContent.sSelectFilter)
        }
      },
      model: {
        value: (item.sBie),
        callback: function($$v) {
          _vm.$set(item, "sBie", $$v)
        },
        expression: "item.sBie"
      }
    }, _vm._l((_vm.view2.sContent.table), function(a) {
      return _c('el-option', {
        key: a.sBie,
        attrs: {
          "label": a.sName + '(' + a.sBie + ')',
          "value": a.sBie
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      on: {
        "change": function($event) {
          return _vm.change5(item)
        }
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }, _vm._l((item.codes), function(a) {
      return _c('el-option', {
        key: a.sColumnCode,
        attrs: {
          "label": a.sColumnName,
          "value": a.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('el-select', {
      attrs: {
        "placeholder": "Select"
      },
      model: {
        value: (item.fuhao),
        callback: function($$v) {
          _vm.$set(item, "fuhao", $$v)
        },
        expression: "item.fuhao"
      }
    }, _vm._l((_vm.options4), function(a) {
      return (item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1) ? _c('el-option', {
        key: a.id,
        attrs: {
          "label": a.name,
          "value": a.id
        }
      }) : _vm._e()
    }), 1), _vm._v(" "), (item.type != 'Datetime' && item.sSelectName != 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-select', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "multiple": "",
        "multiple-limit": item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1,
        "filterable": "",
        "remote": "",
        "reserve-keyword": "",
        "placeholder": item.type,
        "data-id": index,
        "remote-method": _vm.querySearchAsync2,
        "loading": _vm.loading
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1) : (item.type != 'Datetime' && item.sSelectName == 'T_EDW_FACT_Evtitm_Event_All') ? _c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }) : _c('el-date-picker', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "format": "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "prefix-icon": "xxx",
        "type": "datetime",
        "placeholder": item.type
      },
      model: {
        value: (item.value[0]),
        callback: function($$v) {
          _vm.$set(item.value, 0, $$v)
        },
        expression: "item.value[0]"
      }
    }), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.addList2(_vm.view2.sContent.sSelectFilter)
        }
      }
    }, [_vm._v("Add+")]) : _vm._e(), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteList2(_vm.view2.sContent.sSelectFilter, index)
        }
      }
    }, [_vm._v("Delete-")]) : _vm._e()], 1)
  }), _vm._v(" "), _vm._l((_vm.view2.sContent.sSelectFieldName), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Columns"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "indeterminate": item.isIndeterminate
      },
      on: {
        "change": function($event) {
          return _vm.handleCheckAllChange2(item)
        }
      },
      model: {
        value: (item.checkAll),
        callback: function($$v) {
          _vm.$set(item, "checkAll", $$v)
        },
        expression: "item.checkAll"
      }
    }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.sNameAll) + "(" + _vm._s(item.sBie) + ")")]), _vm._v(" "), _c('el-checkbox-group', {
      on: {
        "change": _vm.handleCheckedCitiesChange2
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(a) {
      return _c('el-checkbox', {
        key: a.sColumnCode,
        attrs: {
          "label": a.sColumnCode
        }
      }, [_vm._v(_vm._s(a.sColumnName))])
    }), 1)], 1)
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save3
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save31
    }
  }, [_vm._v("Save as")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible31 = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view2.sViewName + 'Display result',
      "visible": _vm.dialogVisible4,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible4 = $event
      }
    }
  }, [(_vm.count < 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showListFlag = !_vm.showListFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.showListFlag == true ? 'Hide' : 'Display'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addDownLoad2
    }
  }, [_vm._v("\n\t\t\t\t\tDownload\n\t\t\t\t\t"), (_vm.timer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.timer) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showListFlag) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #eee",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "500px",
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, _vm._l((_vm.displayArr), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "width": "200",
        "formatter": _vm.timeFormatter,
        "prop": item,
        "label": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.count >= 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "10px 0"
    }
  }, [_c('h2', [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("\n\t\t\t\t\tToo much data,unable to export!\n\t\t\t\t")])]) : _vm._e()])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Stored Procedure",
      "name": "third"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData3,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.sp
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sViewName",
      "label": "Favorite"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dTime",
      "label": "Time"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nDownloads",
      "label": "Downloads"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total3
    },
    on: {
      "current-change": _vm.handleCurrentChange3
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view3.sViewName,
      "visible": _vm.dialogVisible5,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible5 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.view3.sContent.sName))]), _vm._v(" "), _vm._l((_vm.view3.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticClass: "span-label",
      staticStyle: {
        "text-align": "right",
        "display": "inline-block",
        "width": "300px"
      }
    }, [_vm._v(_vm._s(item.sParameterName))]), _vm._v(" "), _c('label', [_vm._v("=")]), _vm._v(" "), _c('span', {
      staticClass: "span-label",
      staticStyle: {
        "max-height": "100px",
        "overflow": "auto",
        "vertical-align": "middle"
      }
    }, [_vm._v(_vm._s(_vm.arrToString(item.value)))])])
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Display Columns"
    }
  }, _vm._l((_vm.view3.sContent.sSelectFieldName), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "span-label"
    }, [_vm._v(_vm._s(item.sColumnName))])
  }), 0)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doQuery3
    }
  }, [_vm._v("Query")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.doEdit3
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.delete3
    }
  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view3.sViewName + 'Edit',
      "visible": _vm.dialogVisible51,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible51 = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Table"
    }
  }, [_vm._v(_vm._s(_vm.view3.sContent.sName))]), _vm._v(" "), _vm._l((_vm.view3.sContent.sSelectFilter), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": 'Condition.' + (index + 1)
      }
    }, [_c('span', {
      staticStyle: {
        "text-align": "right",
        "display": "inline-block",
        "width": "300px"
      }
    }, [(item.sRequired == 1) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.sParameterName) + "\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t=\n\t\t\t\t\t"), (item.sParameterType != 'Datetime') ? _c('el-select', {
      staticClass: "user-select-max-height",
      attrs: {
        "filterable": "",
        "clearable": "",
        "multiple": "",
        "placeholder": item.sParameterType
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }, _vm._l((item.options), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    }), 1) : _c('el-date-picker', {
      staticStyle: {
        "padding": "0"
      },
      attrs: {
        "format": "yyyy-MM-dd HH:mm:ss",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "prefix-icon": "xxx",
        "type": "datetime",
        "placeholder": item.type
      },
      model: {
        value: (item.value[0]),
        callback: function($$v) {
          _vm.$set(item.value, 0, $$v)
        },
        expression: "item.value[0]"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Columns"
    }
  }, _vm._l((_vm.view3.sContent.sSelectFieldName), function(a) {
    return _c('el-checkbox', {
      key: a.sColumnCode,
      attrs: {
        "disabled": ""
      },
      model: {
        value: (_vm.allCheck),
        callback: function($$v) {
          _vm.allCheck = $$v
        },
        expression: "allCheck"
      }
    }, [_vm._v(_vm._s(a.sColumnName))])
  }), 1)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save5
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save51
    }
  }, [_vm._v("save as")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible51 = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.view3.sViewName + 'Display result',
      "visible": _vm.dialogVisible6,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible6 = $event
      }
    }
  }, [(_vm.count < 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showListFlag = !_vm.showListFlag
      }
    }
  }, [_vm._v(_vm._s(_vm.showListFlag == true ? 'Hide' : 'Display'))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.addDownLoad3
    }
  }, [_vm._v("\n\t\t\t\t\tDownload\n\t\t\t\t\t"), (_vm.timer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.timer) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.showListFlag) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #eee",
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "height": "500px",
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    }
  }, _vm._l((_vm.view3.sContent.sSelectFieldName), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "width": "200",
        "formatter": _vm.timeFormatter,
        "prop": item.sColumnCode,
        "label": item.sColumnName
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.count >= 1000000) ? _c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "10px 0"
    }
  }, [_c('h2', [_c('label', [_vm._v("Row Count.")]), _vm._v(" "), _c('span', {
    staticClass: "span-label"
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("\n\t\t\t\t\tToo much data,unable to export!\n\t\t\t\t")])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8744f94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/favorite.vue
// module id = 679
// module chunks = 1